import { PublicationTypeId } from './PublicationTypeId'

// list built from Zotero data
export const PublicationTypes = [
  {
    id: PublicationTypeId.NOTE,
    label: 'Note',
  },
  {
    id: PublicationTypeId.BOOK,
    label: 'Book',
  },
  {
    id: PublicationTypeId.BOOK_SECTION,
    label: 'Book Section',
  },
  {
    id: PublicationTypeId.JOURNAL_ARTICLE,
    label: 'Journal Article',
  },
  {
    id: PublicationTypeId.MAGAZINE_ARTICLE,
    label: 'Magazine Article',
  },
  {
    id: PublicationTypeId.NEWSPAPER_ARTICLE,
    label: 'Newspaper Article',
  },
  {
    id: PublicationTypeId.THESIS,
    label: 'Thesis',
  },
  {
    id: PublicationTypeId.LETTER,
    label: 'Letter',
  },
  {
    id: PublicationTypeId.MANUSCRIPT,
    label: 'Manuscript',
  },
  {
    id: PublicationTypeId.INTERVIEW,
    label: 'Interview',
  },
  {
    id: PublicationTypeId.FILM,
    label: 'Film',
  },
  {
    id: PublicationTypeId.ARTWORK,
    label: 'Artwork',
  },
  {
    id: PublicationTypeId.WEBPAGE,
    label: 'Web Page',
  },
  {
    id: PublicationTypeId.ATTACHMENT,
    label: 'Attachment',
  },
  {
    id: PublicationTypeId.REPORT,
    label: 'Report',
  },
  {
    id: PublicationTypeId.BILL,
    label: 'Bill',
  },
  {
    id: PublicationTypeId.CASE,
    label: 'Case',
  },
  {
    id: PublicationTypeId.HEARING,
    label: 'Hearing',
  },
  {
    id: PublicationTypeId.PATENT,
    label: 'Patent',
  },
  {
    id: PublicationTypeId.STATUTE,
    label: 'Statute',
  },
  {
    id: PublicationTypeId.EMAIL,
    label: 'E-mail',
  },
  {
    id: PublicationTypeId.MAP,
    label: 'Map',
  },
  {
    id: PublicationTypeId.BLOG_POST,
    label: 'Blog Post',
  },
  {
    id: PublicationTypeId.INSTANT_MESSAGE,
    label: 'Instant Message',
  },
  {
    id: PublicationTypeId.FORUM_POST,
    label: 'Forum Post',
  },
  {
    id: PublicationTypeId.AUDIO_RECORDING,
    label: 'Audio Recording',
  },
  {
    id: PublicationTypeId.PRESENTATION,
    label: 'Presentation',
  },
  {
    id: PublicationTypeId.VIDEO_RECORDING,
    label: 'Video Recording',
  },
  {
    id: PublicationTypeId.TV_BROADCAST,
    label: 'TV Broadcast',
  },
  {
    id: PublicationTypeId.RADIO_BROADCAST,
    label: 'Radio Broadcast',
  },
  {
    id: PublicationTypeId.PODCAST,
    label: 'Podcast',
  },
  {
    id: PublicationTypeId.COMPUTER_PROGRAM,
    label: 'Computer Program',
  },
  {
    id: PublicationTypeId.CONFERENCE_PAPER,
    label: 'Conference Paper',
  },
  {
    id: PublicationTypeId.DOCUMENT,
    label: 'Document',
  },
  {
    id: PublicationTypeId.ENCYCLOPEDIA_ARTICLE,
    label: 'Encyclopedia Article',
  },
  {
    id: PublicationTypeId.DICTIONARY_ENTRY,
    label: 'Dictionary Entry',
  },
]

export const defaultPublicationType = PublicationTypes[3]
